import { createRoute, redirect } from "@tanstack/react-router";
import { fetchCurrentUser } from "@/lib/auth";
import { dashboardPathFor, type RouterContext } from "@/routing/guards";
import { rootRoute } from "./__root";

const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/",
  beforeLoad: async ({
    context,
    cause,
  }: {
    context: RouterContext;
    cause: "preload" | "enter" | "stay";
  }) => {
    const user = await fetchCurrentUser(context.queryClient, {
      fresh: cause === "enter",
    });
    throw redirect({ to: user ? dashboardPathFor(user) : "/login" });
  },
});

export const publicRoutes = [indexRoute];
